import { populate } from "populate";

const raw = {
  width: 1350,
  height: 760,
  x: 50,
  y: 50,
  list: [
    {
      id: "66f72a3c-714b-4107-85ef-debdde1e4bbc",
      type: "Container",
      name: "root",
      nameSpace: "",
      className: "",
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      parent: "",
      data: ""
    },
    {
      id: "0e7916fb-ce02-4d11-b4a4-68edec491366",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.95,
        y: 0.85
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "popup_background",
      parent: "66f72a3c-714b-4107-85ef-debdde1e4bbc",
      data: ""
    },
    {
      id: "4d18fe6c-9b59-4d60-a974-5948233bb079",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 0,
      y: 35,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1.1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "level_complete_underlay",
      parent: "66f72a3c-714b-4107-85ef-debdde1e4bbc",
      data: ""
    },
    {
      id: "59ee2a92-3d10-415b-92e1-5b45cce4deb3",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 0,
      y: -250,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "popup_title_bg",
      parent: "66f72a3c-714b-4107-85ef-debdde1e4bbc",
      data: ""
    },
    {
      id: "0b032071-1a94-406b-8e3a-0445dab92902",
      type: "Text",
      name: "",
      nameSpace: "",
      className: "",
      x: 0,
      y: -260,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      text: "AreYouSure",
      localize: true,
      maxWidth: 459,
      maxHeight: 92,
      maxFontSize: 52,
      icons: [],
      style: {
        fontSize: 26,
        fontWeight: "normal",
        fontFamily: "FrancoisOne",
        fill: "#ffffff",
        stroke: "#A92B40",
        strokeThickness: 5,
        align: "left",
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: "normal",
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: "black",
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: "round",
        miterLimit: 10,
        trim: false,
        textBaseline: "alphabetic",
        whiteSpace: "pre",
        fontVariant: "normal",
        letterSpacing: 0
      },
      parent: "66f72a3c-714b-4107-85ef-debdde1e4bbc",
      data: ""
    },
    {
      id: "0cfc3aee-11df-487c-b272-15ad55069622",
      type: "Text",
      name: "",
      nameSpace: "",
      className: "",
      x: 0,
      y: -10,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      text: "WheelQuitConfirm",
      localize: true,
      maxWidth: 619,
      maxHeight: 247,
      maxFontSize: 36,
      icons: [],
      style: {
        fontSize: 26,
        fontWeight: "normal",
        fontFamily: "FrancoisOne",
        fill: "#892D2D",
        stroke: "#A92B40",
        strokeThickness: 0,
        align: "center",
        wordWrap: true,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: "normal",
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: "black",
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: "round",
        miterLimit: 10,
        trim: false,
        textBaseline: "alphabetic",
        whiteSpace: "pre",
        fontVariant: "normal",
        letterSpacing: 0
      },
      parent: "66f72a3c-714b-4107-85ef-debdde1e4bbc",
      data: ""
    },
    {
      id: "437e34be-e81e-418b-8fd2-bc75a27d1191",
      type: "Container",
      name: "",
      nameSpace: "",
      className: "",
      x: -148,
      y: 252,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      parent: "66f72a3c-714b-4107-85ef-debdde1e4bbc",
      data: ""
    },
    {
      id: "5df2b60a-d95f-4e29-8ae3-715016ac47ea",
      type: "Container",
      name: "",
      nameSpace: "",
      className: "",
      x: 148,
      y: 252,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      parent: "66f72a3c-714b-4107-85ef-debdde1e4bbc",
      data: ""
    },
    {
      id: "b760bbb0-182b-44b7-b883-d8df169044af",
      type: "Sprite",
      name: "closeButton",
      nameSpace: "",
      className: "",
      x: 323,
      y: -211,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: true,
      buttonMode: true,
      hitArea: {
        type: "None"
      },
      texture: "button_close",
      parent: "66f72a3c-714b-4107-85ef-debdde1e4bbc",
      data: ""
    },
    {
      id: "73357c1a-9a99-4af4-9711-bdccc082841b",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blank",
      parent: "437e34be-e81e-418b-8fd2-bc75a27d1191",
      data: ""
    },
    {
      id: "fa913744-8213-411e-b7f1-6031b6ea1b8a",
      type: "Sprite",
      name: "leaveButton",
      nameSpace: "",
      className: "",
      x: 0,
      y: 2,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.96,
        y: 0.96
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: true,
      buttonMode: true,
      hitArea: {
        type: "None"
      },
      texture: "button_stop",
      parent: "437e34be-e81e-418b-8fd2-bc75a27d1191",
      data: ""
    },
    {
      id: "f71c99de-fd8f-41d9-90ae-c0ff3986bacb",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blank",
      parent: "5df2b60a-d95f-4e29-8ae3-715016ac47ea",
      data: ""
    },
    {
      id: "4fc3bf09-c7f5-42f0-90f1-b08af718c88b",
      type: "Sprite",
      name: "stayButton",
      nameSpace: "",
      className: "",
      x: 0,
      y: 2,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.96,
        y: 0.96
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: true,
      buttonMode: true,
      hitArea: {
        type: "None"
      },
      texture: "button_play",
      parent: "5df2b60a-d95f-4e29-8ae3-715016ac47ea",
      data: ""
    },
    {
      id: "6600a8de-a052-4715-bcf0-c95e1f5e75bb",
      type: "Text",
      name: "",
      nameSpace: "",
      className: "",
      x: 0,
      y: -10,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      text: "Leave",
      localize: true,
      maxWidth: 224,
      maxHeight: 92,
      maxFontSize: 54,
      icons: [],
      style: {
        fontSize: 26,
        fontWeight: "normal",
        fontFamily: "FrancoisOne",
        fill: "#ffffff",
        stroke: "#7C0F19",
        strokeThickness: 5,
        align: "left",
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: "normal",
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: "black",
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: "round",
        miterLimit: 10,
        trim: false,
        textBaseline: "alphabetic",
        whiteSpace: "pre",
        fontVariant: "normal",
        letterSpacing: 0
      },
      parent: "fa913744-8213-411e-b7f1-6031b6ea1b8a",
      data: ""
    },
    {
      id: "0e8fbd06-7ebf-461d-afbe-07f93176231f",
      type: "Text",
      name: "",
      nameSpace: "",
      className: "",
      x: 0,
      y: -10,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      text: "Stay",
      localize: true,
      maxWidth: 224,
      maxHeight: 92,
      maxFontSize: 54,
      icons: [],
      style: {
        fontSize: 26,
        fontWeight: "normal",
        fontFamily: "FrancoisOne",
        fill: "#ffffff",
        stroke: "#036D1F",
        strokeThickness: 5,
        align: "left",
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: "normal",
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: "black",
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: "round",
        miterLimit: 10,
        trim: false,
        textBaseline: "alphabetic",
        whiteSpace: "pre",
        fontVariant: "normal",
        letterSpacing: 0
      },
      parent: "4fc3bf09-c7f5-42f0-90f1-b08af718c88b",
      data: ""
    }
  ]
} as const;

export class WheelQuitConfirmLayout {
  static raw = raw;
  root: GameObject<PIXI.Container>;
  leaveButton: GameObject<PIXI.Sprite>;
  stayButton: GameObject<PIXI.Sprite>;
  closeButton: GameObject<PIXI.Sprite>;

  constructor() {
    populate(this, raw);
  }
}
